var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7684 16.2333C20.7442 17.2091 20.7442 18.7933 19.7684 19.7708C18.7926 20.7466 17.2084 20.7466 16.2309 19.7708C15.2551 18.795 15.2551 17.2108 16.2309 16.2333C17.2084 15.2558 18.7917 15.2558 19.7684 16.2333",
    stroke: "#653494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 18C10.5 17.4508 10.6267 16.9075 10.8717 16.4067V16.4067C12.1342 13.8258 14.9242 12.1667 18 12.1667C21.0758 12.1667 23.8658 13.8258 25.1283 16.4067V16.4067C25.3733 16.9075 25.5 17.4508 25.5 18C25.5 18.5492 25.3733 19.0925 25.1283 19.5933V19.5933C23.8658 22.1742 21.0758 23.8333 18 23.8333C14.9242 23.8333 12.1342 22.1742 10.8717 19.5933V19.5933C10.6267 19.0925 10.5 18.5492 10.5 18Z",
    stroke: "#653494",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.c74fbe3bc89db53011470e7bab68e8f8.svg";
export { ForwardRef as ReactComponent };